/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div class="row">
    <div class="col-sm-6 col-sm-offset-3">
      <h1>Reset Password</h1>
      <form @submit.prevent="resetPassword">
        <div class="form-group">
          <label>Email</label>
          <input
            v-model.trim="formValues.email"
            type="email"
            class="form-control"
            readonly
          >
        </div>
        <div class="form-group">
          <label for="resetPwdPassword">
            New password
          </label>
          <input
            id="resetPwdPassword"
            v-model.trim="formValues.newPassword"
            type="password"
            class="form-control"
            placeholder="password"
            required
          >
        </div>
        <div class="help-block" />
        <loading-button
          type="submit"
          :loading="saving"
        >
          Reset password
        </loading-button>
      </form>
    </div>
  </div>
</template>

<script>
import service from '../../services/auth';

export default {
  data() {
    return {
      saving: false,
      formValues: {
        email: this.$route.query.email || '',
        token: this.$route.query.token,
        newPassword: '',
      },
      errors: {}
    };
  },
  methods: {
    resetPassword() {
      this.saving = true;
      service.resetPassword(this.formValues)
        .then(() => {
          this.$store.dispatch('notify', {
            type: 'success',
            subject: 'Updated!',
            text: 'Your password has been updated, you can sign in now'
          });
          this.$router.push({ name: 'sign-in', query: { email: this.formValues.email }});
        })
        .catch(() => {
          this.saving = false;
        });
    }
  }
};
</script>
